export const currencyTransform = (value, locale = 'el-GR') => {
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR'
    });
    return formatter.format(value);
};

export const currencyNoSymbolTransform = (value, locale = 'el-GR') => {
    const currencyFractionDigits = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'EUR'
    }).resolvedOptions().maximumFractionDigits;

    const newValue = value.toLocaleString(locale, {
        maximumFractionDigits: currencyFractionDigits
    });
    return newValue;
};
